// extracted by mini-css-extract-plugin
export default {"btop":"_3ba15d7a92 _7300509542 _8bf85d0ade","icon":"_7071e89bf3 _086be613ff","btoppink":"_3b9a070b74 _030e75194d"};